export const allSortMethod = [
  {
    sortId: 'sortItem.best_seller',
    sortText: 'Best Sellers',
    sortAttribute: 'best_seller',
    sortDirection: 'DESC',
    sortQuery: 'best_sellers',
  },
  {
    sortId: 'sortItem.position',
    sortText: 'Featured',
    sortAttribute: 'position',
    sortDirection: 'ASC',
    sortQuery: 'featured',
  },
  {
    sortId: 'sortItem.created_at',
    sortText: 'New Arrivals',
    sortAttribute: 'created_at',
    sortDirection: 'DESC',
    sortQuery: 'new',
  },
  {
    sortId: 'sortItem.high_to_low',
    sortText: 'Price: High to Low',
    sortAttribute: 'high_to_low',
    sortDirection: 'DESC',
    sortQuery: 'price_high',
  },
  {
    sortId: 'sortItem.low_to_high',
    sortText: 'Price: Low to High',
    sortAttribute: 'low_to_high',
    sortDirection: 'ASC',
    sortQuery: 'price_low',
  },
  {
    sortId: 'sortItem.most_reviews',
    sortText: 'Top Rated',
    sortAttribute: 'most_reviews',
    sortDirection: 'DESC',
    sortQuery: 'top_rated',
  },
];
